import { render, staticRenderFns } from "./restock.vue?vue&type=template&id=976237d0&scoped=true&"
import script from "./restock.vue?vue&type=script&lang=js&"
export * from "./restock.vue?vue&type=script&lang=js&"
import style0 from "./restock.vue?vue&type=style&index=0&id=976237d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976237d0",
  null
  
)

export default component.exports